import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Navbar, Footer, theme } from "./components";
import { CssBaseline, ThemeProvider } from "@mui/material";
import {
	ContactUs,
	APEGenForm,
	TaskStatus,
	Results,
	Method,
	About,
	SearchDB,
	MolstarViewer,
	AnalysisViewer,
} from "./pages/exports";
import { footerColor, navbarColor } from "./constants";
import {Help} from "./pages/help";

/**
 * Top-level defined source for React to render elements on different pages.
 * Each JSX element is imported from pages.tsx.
 */
const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement
);
root.render(
	<React.StrictMode>
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<BrowserRouter>
				<Routes>
					<Route
						element={
							<section className="wholePage">
								<Navbar
									title="Structural TCR-pHLA Ensemble Generator and Gallery"
									pageLinkMap={{
										"Generate Ensembles": "/",
										"Search Database":"/search",
										// "Analyze Ensembles":"/search",
										About: "/about",
										Help: "/help"
									}}
									color={navbarColor}
								/>
								<Outlet />
								<Footer backgroundColor={footerColor} />
							</section>
						}
					>
						<Route path="/" element={<APEGenForm />} />
						<Route path="/method" element={<Method />} />
						<Route path="/about" element={<About />} />
						<Route path="/contactus" element={<ContactUs />} />
						<Route path="/help" element={<Help />} />
						<Route path="/search" element={<SearchDB />} />
						<Route path="/analyze/:complex_id" element={<AnalysisViewer />} /> 
						<Route path="/results/:job_id" element={<Results />} />
						<Route path="/viewer" element={<MolstarViewer />} />
						<Route
							path="/task_status/:job_id"
							element={<TaskStatus />}
						/>
					</Route>
				</Routes>
			</BrowserRouter>
		</ThemeProvider>
	</React.StrictMode>
);
